import React from 'react';
import { motion } from 'framer-motion';
interface SectionHeaderProps {
  title: string;
  subtitle?: string;
}
export function SectionHeader({
  title,
  subtitle
}: SectionHeaderProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.6
  }} className="py-16 sm:py-20 md:py-24 bg-deep-blue" data-id="element-244">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-245">
        <h1 className="font-heading font-semibold text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white mb-3 sm:mb-4" data-id="element-246">
          {title}
        </h1>
        {subtitle && <p className="text-white/70 text-base sm:text-lg md:text-xl max-w-3xl mx-auto px-4" data-id="element-247">
            {subtitle}
          </p>}
      </div>
    </motion.div>;
}